import React from 'react';

import EMOJI_REACTIONS_MAP from 'constants/emojiReactions';

import EmojiIconButton from './emoji-icon-button';

const filterNervous = type => type != 'nervous';

// import styles from './styles.module.less';

const EmojiReactionSet = props => {
  const { disabled, onClick, size, fromEndScreen, forceSmallIcon } = props;

  return (
    <div className="pl:small pr:small">
      {Object.values(EMOJI_REACTIONS_MAP)
        .filter(filterNervous)
        .map(type => (
          <EmojiIconButton
            disabled={disabled}
            key={type}
            type={type}
            onClick={onClick}
            size={size}
            fromEndScreen={fromEndScreen}
            forceSmallIcon={forceSmallIcon}
          />
        ))}
    </div>
  );
};

export default EmojiReactionSet;
